// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionCardBasicInfo_basic-info__b\\+iHP {
  width: 100%;
}
.InstitutionCardBasicInfo_basic-info__b\\+iHP .InstitutionCardBasicInfo_tabs__OaQpW {
  min-height: 0;
  border-bottom: 1px solid var(--light-grey);
  overflow-x: auto;
}
.InstitutionCardBasicInfo_basic-info__b\\+iHP .InstitutionCardBasicInfo_tabs--item__6ck9W {
  min-width: 0;
  min-height: 0;
  text-transform: initial;
  font-size: 13px;
}
.InstitutionCardBasicInfo_basic-info__b\\+iHP .InstitutionCardBasicInfo_tabs--item__6ck9W.InstitutionCardBasicInfo_selected__rSlLG {
  color: var(--secondary-color);
}
.InstitutionCardBasicInfo_basic-info__b\\+iHP .InstitutionCardBasicInfo_tabs--indicator__5qsZf {
  background-color: var(--secondary-color);
}
.InstitutionCardBasicInfo_basic-info__b\\+iHP .InstitutionCardBasicInfo_tabs--content__evnQw {
  padding: 8px;
  max-height: 400px;
  overflow-y: auto;
}
.InstitutionCardBasicInfo_basic-info__b\\+iHP .InstitutionCardBasicInfo_scholars-list__2s6U- {
  display: flex;
  flex-direction: column;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/InstitutionCard/BasicInfo/InstitutionCardBasicInfo.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,aAAA;EACA,0CAAA;EACA,gBAAA;AAEJ;AAAI;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAEN;AAAM;EACE,6BAAA;AAER;AAEI;EACE,wCAAA;AAAN;AAGI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;AADN;AAKE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHJ","sourcesContent":[".basic-info {\n  width: 100%;\n  .tabs {\n    min-height: 0;\n    border-bottom: 1px solid var(--light-grey);\n    overflow-x: auto;\n\n    &--item {\n      min-width: 0;\n      min-height: 0;\n      text-transform: initial;\n      font-size: 13px;\n\n      &.selected {\n        color: var(--secondary-color);\n      }\n    }\n\n    &--indicator {\n      background-color: var(--secondary-color);\n    }\n\n    &--content {\n      padding: 8px;\n      max-height: 400px;\n      overflow-y: auto;\n    }\n  }\n\n  .scholars-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basic-info": `InstitutionCardBasicInfo_basic-info__b+iHP`,
	"tabs": `InstitutionCardBasicInfo_tabs__OaQpW`,
	"tabs--item": `InstitutionCardBasicInfo_tabs--item__6ck9W`,
	"selected": `InstitutionCardBasicInfo_selected__rSlLG`,
	"tabs--indicator": `InstitutionCardBasicInfo_tabs--indicator__5qsZf`,
	"tabs--content": `InstitutionCardBasicInfo_tabs--content__evnQw`,
	"scholars-list": `InstitutionCardBasicInfo_scholars-list__2s6U-`
};
export default ___CSS_LOADER_EXPORT___;
